import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function CheckEmail() {
  const location = useLocation();
  const email = location.state?.email || (typeof sessionStorage !== "undefined" ? sessionStorage.getItem("gx_verify_email") : "") || "";
  if (location.state?.email && typeof sessionStorage !== "undefined") {
    sessionStorage.setItem("gx_verify_email", location.state.email);
  }
  const [resending, setResending] = useState(false);
  const [msg, setMsg] = useState("");

  const resend = async () => {
    if (!email) return;
    setResending(true);
    setMsg("");
    try {
      const { data } = await api.post("/auth/resend-verification", { email });
      setMsg(data.message || "Verification email sent.");
    } catch (err) {
      setMsg(formatApiErrorDetail(err.response?.data?.detail) || "Couldn't resend right now.");
    } finally {
      setResending(false);
    }
  };

  return (
    <AuthShell>
      <div className="text-center" data-testid="check-email-page">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary">
          <MailCheck className="h-7 w-7" />
        </div>
        <p className="gx-label mt-6">Verification required</p>
        <h2 className="mt-2 font-display text-3xl font-bold tracking-tight">Check your inbox</h2>
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
          We created your account but you cannot sign in until the email is verified.
          {email ? (
            <> A link was sent to <strong className="text-foreground">{email}</strong>.</>
          ) : (
            <> Open the verification email we just sent.</>
          )}
        </p>
        <p className="mt-2 text-xs text-muted-foreground">The link expires in 24 hours. Check spam if you don't see it.</p>

        {email && (
          <Button
            type="button"
            variant="outline"
            className="mt-6 h-11 rounded-xl"
            onClick={resend}
            disabled={resending}
            data-testid="check-email-resend"
          >
            {resending ? <Loader2 className="h-4 w-4 animate-spin" /> : "Resend verification email"}
          </Button>
        )}
        {msg && <p className="mt-3 text-xs text-muted-foreground" data-testid="check-email-msg">{msg}</p>}

        <div className="mt-8">
          <Button asChild className="h-11 rounded-xl px-6" data-testid="check-email-to-login">
            <Link to="/login" state={{ email, justSignedUp: true }}>I have verified — sign in</Link>
          </Button>
        </div>
      </div>
    </AuthShell>
  );
}
